var React = require('react');

function IconCollapse (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM12 7H4V9H12V7Z","fill":"currentColor"}));
}

IconCollapse.defaultProps = {"viewBox":"0 0 16 16","fill":"none","style":{"color":"#39424A"}};

module.exports = IconCollapse;

IconCollapse.default = IconCollapse;
